import { createAPI } from '@common'
export default {
  // 稿件检索
  postRrAMArticles: config => createAPI('customEncryptApiName-1/w20ss0BNBsujdmft', 'POST', config),
  // 保存转发记录
  postRrAMArticlesForward: config => createAPI('customEncryptApiName-1/0w20ss0NDBsujdmft0gpsxbse', 'POST', config),
  // 稿件详情
  getRrAMArticlesDetail: config => createAPI('customEncryptApiName-1/0w20ss0BNBsujdmft0efubjm', 'GET', config),
  // 栏目树
  getRrAMArticlesColumns: config => createAPI('customEncryptApiName-1/0w20BNBsujdmft0dpmvnot', 'GET', config),
  // 必推稿库-回退
  postArticlesBack: config => createAPI('customEncryptApiName-1/0w20bsujdmft0cbdl', 'post', config),
  // 删除栏目
  deleteAmColumn: config => createAPI('customEncryptApiName-1/0w20bn0dpmvno', 'DELETE', config)
}
